<template>
  <v-container fluid class="pa-0">
    <v-card outlined class="rounded-lg pa-4">
      <div class="d-flex align-center mb-4">
        <v-avatar size="48" class="section-icon mr-3" rounded>
          <v-icon color="white">mdi-palette-outline</v-icon>
        </v-avatar>
        <div>
          <div class="text-subtitle-1 font-weight-bold primary--text">Choose a Website Template</div>
          <div class="text-caption grey--text">Pick a design theme for your school's public website</div>
        </div>
      </div>

      <v-row>
        <v-col
          v-for="template in templates"
          :key="template.name"
          cols="12" sm="4"
        >
          <v-card outlined :class="['rounded-lg template-card', { 'template-card-selected': selected === template.name }]">
            <v-img :src="template.thumbnail" aspect-ratio="1.78" class="rounded-t-lg">
              <v-chip v-if="selected === template.name" small color="success" dark class="ma-2">
                <v-icon left small>mdi-check-circle</v-icon>
                Active
              </v-chip>
            </v-img>
            <v-card-title class="text-subtitle-1 font-weight-bold primary--text">{{ template.label }}</v-card-title>
            <v-card-actions>
              <v-btn
                :color="selected === template.name ? 'success' : 'primary'"
                :outlined="selected !== template.name"
                rounded
                block
                class="font-weight-bold text-none"
                @click="applyTemplate(template.name)"
                :disabled="selected === template.name"
              >
                <v-icon left>{{ selected === template.name ? 'mdi-check' : 'mdi-check-circle-outline' }}</v-icon>
                {{ selected === template.name ? 'Selected' : 'Apply' }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import axios from 'axios';
export default {
  props: ['websiteId'],
  data() {
    return {
      selected: null,
      templates: [
        {
          name: 'default',
          label: 'Default Template',
          thumbnail: '/templates/default-thumb.png',
        },
        {
          name: 'modern',
          label: 'Modern Template',
          thumbnail: '/templates/modern-thumb.png',
        },
        {
          name: 'classic',
          label: 'Classic Template',
          thumbnail: '/templates/classic-thumb.png',
        },
      ]
    };
  },
  async mounted() {
    const res = await axios.get(`/api/websites/${this.websiteId}/template`);
    this.selected = res.data.template;
  },
  methods: {
    async applyTemplate(templateName) {
      await axios.put(`/api/websites/${this.websiteId}/template`, {
        template: templateName
      });
      this.selected = templateName;
      this.$toast.success('Template applied!');
    }
  }
};
</script>

<style scoped>
.section-icon {
    background: linear-gradient(135deg, #1E3C72 0%, #2A5298 100%);
}
.template-card {
    border: 1px solid #ECEFF7;
    transition: box-shadow 0.2s ease, border-color 0.2s ease;
}
.template-card-selected {
    border-color: #1E3C72;
    box-shadow: 0 0 0 2px rgba(30, 60, 114, 0.15);
}
</style>
